/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [comments, setComments] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setComments(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>شماره پرداخت</th>
            <th>شماره سفارش</th>
            <th>امتیاز</th>
            <th>وضعیت</th>
            <th>وضعیت بررسی</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {comments ? comments.map(item => (
              <tr key={item._id}>
                <td>{item.order[0].refId}</td>
                <td>{item.order[0].orderNumber}</td>
                <td>{item.score } از 20</td>
                <td style={item.score >= 17 ? { color : '#198524' } : { }}>{ item.score >= 17 ? 'عالی' :  '-' }</td>
                <td style={item.status ? { color: '#198524' } : { color: '#fd3a50' }}>{item.status ? 'بررسی شده' : 'بررسی نشده'}</td>
                <td>
                  <button onClick={() => navigate(`/cc/comments/detail/${item.order[0]._id}`)}>مشاهده</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
